import Region from "../../../../../models/Region";

class DellyCoveragePoint {
  constructor(position, val, chr) {
    this.val = val;
    this.logVal = Math.log10(Math.max(0.1, val));
    this.region = new Region(position, position + 1, chr);
  }
}

export default DellyCoveragePoint;
